<template>
  <div class="col-lg-6 col-md-6 col-sm-12 p-3">
    <div
      class="bg-color-lightblue p-5 text-green rounded mt-3 text-left cursor-pointer compeition-box"
      @click="openLinkNewTab(link)"
    >
      <div class="d-flex justify-content-between">
        <span style="width: 90%"
          ><b>{{ text }}</b></span
        >
        <span class="mt-2 ml-4">
          <right-arrow-svg v-if="!rightArrow" />
          <down-arrow-svg v-else />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import openLinkNewTab from '../../mixins/openLinkNewTab'
import DownArrowSvg from './DownArrow'
import RightArrowSvg from './RightArrow'

export default {
  name: 'CompetitionGuideDownload',
  components: {
    DownArrowSvg,
    RightArrowSvg
  },
  props: ['text', 'link', 'rightArrow'],
  mixins: [openLinkNewTab]
}
</script>
<style scoped>
.compeition-box {
  height: 160px;
  display: flex;
  align-items: center;
}
</style>
